/**
 * @fileoverview Agent definition for world-element-image-prompt-creator-v2.
 *
 * This agent takes world element details (place, set, object, species) and
 * creates a rich, artistic prompt for an image generation model, adapting
 * its approach based on the element type.
 *
 * @category visuals.prompts.world-building
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-element-image-prompt-creator-v2',
  kind: 'primitive',
  name: 'World Element Image Prompt Creator',
  description: 'Takes world element details and creates a rich, artistic prompt for an image generation model. Supports places, sets, objects, and species.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'visuals.prompts.world-building',
    usedBy: [
      'generate-world-element-portrait-v2',
    ],
    usedInComposites: [
      'generate-world-element-portrait-v2',
    ],
    relatedAgents: [
      'world-element-image-creator-fal-v2',
      'portrait-image-prompt-creator-v2',
    ],
  },
};
